module.exports = __webpack_public_path__ + "img/symbol_1.a7a51961.png";